// extracted by mini-css-extract-plugin
export default {"root":"styles_root__QdIH3","footer":"styles_footer__1BKlR"};